import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  duration?: number;
  action?: string;
}

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input() toast!: Toast;
  @Output() close = new EventEmitter<string>();

  private timeoutId?: number;

  ngOnInit(): void {
    if (this.toast.duration && this.toast.duration > 0) {
      this.timeoutId = window.setTimeout(() => {
        this.onClose();
      }, this.toast.duration);
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  get icon(): string {
    switch (this.toast.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
      default:
        return 'info';
    }
  }

  get iconColor(): string {
    switch (this.toast.type) {
      case 'success':
        return '#107c10';
      case 'error':
        return '#d13438';
      case 'warning':
        return '#ca5010';
      case 'info':
      default:
        return '#0078d4';
    }
  }

  onClose(): void {
    this.close.emit(this.toast.id);
  }

  onAction(): void {
    // Handle action if needed
  }
}
